import { auditService, auditSignedUrlService, auditOrderLists } from 'config/api';
import { format } from 'date-fns';

export const getOrderLists = (requestPayload) => async () => {
  const { selectedStoreId, range } = requestPayload;
  const { startDate, endDate } = range;
  const urlParams = `startDate=${format(startDate, 'yyyy-MM-dd')}&endDate=${format(endDate, 'yyyy-MM-dd')}`;

  try {
    const { data } = await auditOrderLists.get(`/${selectedStoreId}?${urlParams}`);
    return data;
  } catch (error) {
    return error;
  }
};

export const retrieveDailyReceiptReport = (requestPayload) => async () => {
  const { selectedStoreId, range, orderNumber } = requestPayload;
  const { startDate } = range;
  const payload = {
    filePath: `receipts/${format(startDate, 'yyyyMMdd')}/${selectedStoreId}/${orderNumber}.txt`,
  };

  try {
    const { data } = await auditSignedUrlService.post('', payload);
    return data;
  } catch (error) {
    return error;
  }
};

export const retrieveDailyTotalsReport = (requestPayload) => async () => {
  const { selectedStoreId, range } = requestPayload;
  const { startDate, endDate } = range;
  const dates = `startDate=${format(startDate, 'yyyy-MM-dd')}&endDate=${format(endDate, 'yyyy-MM-dd')}`;

  try {
    const { data } = await auditService.get(`/daily/totals/${selectedStoreId}?${dates}`);
    return data;
  } catch (error) {
    return error;
  }
};
